import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import {
  Alert,
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import defaultEmployeeImage from "../../../../../assets/svg/defaultUser.svg";
import AddIcon from "@mui/icons-material/Add";
import {
  createServiceEmployee,
  validateServiceStorePrices,
} from "../usualFunctions";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import ComercialDrawer from "../../../../../components/pet-beauty/CormercialDrawer";
import ComercialInterfaceHeader from "../../../../../components/comercial/ComercialInterfaceHeader";
import GalleryImageList from "../../../../../components/comercial/ImageGallery";
import ImageGalleryHeader from "../../../../../components/comercial/ImageGallery/ImageGalleryHeader";
import CustomCard from "../../../../../components/general/CustomCard";
import serviceCategoryApi from "../../../../../services/api/ServiceCategory";
import { IServiceCategory } from "../../../../../services/api/ServiceCategory/types";
import serviceStoreApi from "../../../../../services/api/ServiceStore";
import { IStore } from "../../../../../services/api/Store/types";
import { IServiceStore } from "../../../../../services/api/ServiceStore/types";
import PriceInput from "../../../../../components/general/PriceInput";
import { addServiceSchema } from "../../../../../utils/yupSchemas";
import DynamicPriceInput from "../DynamicPriceInput";
import { PrimaryButton } from "../../../../../components/general/buttons/PrimaryButton";
import {
  CURRENT_SUBDOMAIN,
  getServiceStoresFirebasePath,
} from "../../../../../utils/stringUtils";
import { sharedStyles } from "../../../../../styles/shared";
import { SecondaryButton } from "../../../../../components/general/buttons/SecondaryButton";
import { getLocalStorageItem } from "../../../../../hooks/localStorageHooks";
import useFetchEmployeesFromStore from "../../../../../hooks/entities/useFetchEmployeesFromStore";
import useFetchSearchServices from "../../../../../hooks/entities/useFetchSearchServices";
import { uploadOriginalAndPreviewImagesToFirebase } from "../../../../../utils/firebase/functions";
import ImageGalleryContainer from "../../../../../components/comercial/ImageGallery/ImageGalleryContainer";
import { LeftMarginBackButton } from "@/components/general/buttons/BackPageButton";
import { useTranslation } from "react-i18next";
const AddService = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const selectedStore: IStore = getLocalStorageItem("selectedStore");

  const {
    register,
    handleSubmit: onSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(addServiceSchema) });

  const serviceNameRef = useRef<HTMLInputElement>(null);
  const [serviceCategory, setServiceCategory] = useState<string>("");
  const { services } = useFetchSearchServices(serviceCategory);

  const [durationOfService, setDurationOfService] = useState<number>(1);

  const descriptionRef = useRef<HTMLInputElement>(null);

  const [dynamicPriceAllowed, setIsDynamicPriceAllowed] = useState(false);
  const [fixedPrice, setFixedPrice] = useState<number | null>(null);

  const [mondayPrice, setMondayPrice] = useState<number | null>(null);
  const [tuesdayPrice, setTuesdayPrice] = useState<number | null>(null);
  const [wednesdayPrice, setWednesdayPrice] = useState<number | null>(null);
  const [thursdayPrice, setThursdayPrice] = useState<number | null>(null);
  const [fridayPrice, setFridayPrice] = useState<number | null>(null);
  const [saturdayPrice, setSaturdayPrice] = useState<number | null>(null);
  const [sundayPrice, setSundayPrice] = useState<number | null>(null);

  const prices = [
    mondayPrice,
    tuesdayPrice,
    wednesdayPrice,
    thursdayPrice,
    fridayPrice,
    saturdayPrice,
    sundayPrice,
  ];

  const setPrices = [
    setMondayPrice,
    setTuesdayPrice,
    setWednesdayPrice,
    setThursdayPrice,
    setFridayPrice,
    setSaturdayPrice,
    setSundayPrice,
  ];

  const weekdayKeys = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const [images, setImages] = useState<HTMLCanvasElement[]>([]);

  const [buttonsDisabled, setButtonsDisabled] = useState<boolean>(false);

  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState<string[]>([]);

  const [noEmployeesSelected, setNoEmployeesSelected] =
    useState<boolean>(false);

  const [submittedOnce, setSubmittedOnce] = useState<boolean>(false);

  const [generalErrorMessage, setGeneralErrorMessage] = useState("");

  const { employees } = useFetchEmployeesFromStore(selectedStore.id);

  const checkIfPricesAreValid = () =>
    validateServiceStorePrices(
      fixedPrice,
      mondayPrice,
      tuesdayPrice,
      wednesdayPrice,
      thursdayPrice,
      fridayPrice,
      saturdayPrice,
      sundayPrice,
      dynamicPriceAllowed
    );

  /* TODO: refactor the function below */
  const handleServiceAndServiceStoreCreation = async () => {
    if (serviceCategory.length > 0 && checkIfPricesAreValid()) {
      const maximumWeekPrice = Math.max(
        mondayPrice,
        tuesdayPrice,
        wednesdayPrice,
        thursdayPrice,
        fridayPrice,
        saturdayPrice,
        sundayPrice
      );

      if (!noEmployeesSelected) {
        setButtonsDisabled(!buttonsDisabled);

        try {
          let serviceCategoryId = "";

          if (services.length === 0) {
            const createdServiceCategoryResponse =
              await serviceCategoryApi.createService({
                name: serviceCategory,
              } as IServiceCategory);

            serviceCategoryId = createdServiceCategoryResponse.id;
          } else serviceCategoryId = services[0].id;

          const serviceName = serviceNameRef.current.value;

          const newServiceStore: IServiceStore = {
            serviceName,
            serviceId: serviceCategoryId,
            storeId: selectedStore.id,
            description: descriptionRef?.current?.value,
            price: !dynamicPriceAllowed ? fixedPrice : maximumWeekPrice,
            imageOriginal: [],
            imagePreview: [],
            priceDay: dynamicPriceAllowed
              ? prices
              : [
                  fixedPrice,
                  fixedPrice,
                  fixedPrice,
                  fixedPrice,
                  fixedPrice,
                  fixedPrice,
                  fixedPrice,
                ],
            durationOfService,
          };

          const createdServiceStoreResponse =
            await serviceStoreApi.createServiceStore(newServiceStore);

          for (const employeeId of selectedEmployeeIds) {
              await createServiceEmployee(
                employeeId,
                createdServiceStoreResponse.id
              );
          }

          if (images.length > 0) {
            const { originalImageUrls, previewImageUrls } =
              await uploadOriginalAndPreviewImagesToFirebase(
                images,
                getServiceStoresFirebasePath(
                  selectedStore.name,
                  selectedStore.id,
                  serviceCategory,
                  createdServiceStoreResponse.id
                )
              );

            newServiceStore.imageOriginal = originalImageUrls;
            newServiceStore.imagePreview = previewImageUrls;

            delete newServiceStore.serviceId;
            delete newServiceStore.storeId;

            await serviceStoreApi.updateServiceStore(
              createdServiceStoreResponse.id,
              newServiceStore
            );
          }

          window.alert(t("servicePage.management.add.success"));
          navigate("/services");
        } catch (error: any) {
          console.error("Error creating a service or services store: ", error);
          setGeneralErrorMessage(error.response.data.message);
        }
        setButtonsDisabled(false);
      }
    }
  };

  const handleSelectEmployee = (employeeId: string) =>
    setSelectedEmployeeIds((prevSelectedEmployeeIds) =>
      !selectedEmployeeIds.includes(employeeId)
        ? [...prevSelectedEmployeeIds, employeeId]
        : prevSelectedEmployeeIds.filter((id) => id !== employeeId)
    );

  const handleToggleDynamicPrices = () =>
    setIsDynamicPriceAllowed(!dynamicPriceAllowed);

  useEffect(() => {
    setNoEmployeesSelected(selectedEmployeeIds.length === 0);
  }, [selectedEmployeeIds]);

  useEffect(() => {
    setGeneralErrorMessage("");
  }, [serviceCategory]);

  const renderServiceData = (
    <>
      <ComercialInterfaceHeader title={t("servicePage.management.form.titleAdd")} />

      <Box sx={sharedStyles.verticalContent}>
        <Box
          sx={{
            ...sharedStyles.verticalContent,
            flexDirection: "row",
            "@media(max-width:800px)": { flexDirection: "column" },
          }}
        >
          <Box
            sx={{
              ...sharedStyles.verticalContent,
              width: "65%",
              "@media(max-width:800px)": { width: "100%" },
            }}
          >
            <TextField
              size="small"
              label={t("servicePage.management.form.serviceName")}
              inputRef={serviceNameRef}
              {...register("name")}
              error={!!errors.name}
              helperText={errors.name?.message}
              fullWidth
            />
          <Box sx={{ ...sharedStyles.verticalContent, flexDirection: "row" }}>
            <Autocomplete
                freeSolo
                options={services.map((service) => service.name)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("servicePage.management.form.category")}
                    size="small"
                    value={serviceCategory}
                    onChange={(e) => setServiceCategory(e.target.value)}
                    {...register("category")}
                    error={!!errors.category}
                    helperText={errors.category?.message}
                />
                )}
                fullWidth
                onInputChange={(_, value) => setServiceCategory(value)}
              />
              <TextField
                size="small"
                label={t("servicePage.management.form.duration")}
                type="number"
                autoComplete="off"
                value={durationOfService}
                onChange={(e) => setDurationOfService(Number(e.target.value))}
                InputProps={{ inputProps: { min: 1 } }}
              />
            </Box>

            <TextField
              size="small"
              label={t("servicePage.management.form.description")}
              multiline
              rows={4}
              fullWidth
              inputRef={descriptionRef}
              placeholder={t("servicePage.management.form.descriptionPlaceholder")}
            />
          </Box>

          <Box
            sx={{
              ...sharedStyles.verticalContent,
              width: "35%",
              "@media(max-width:800px)": { width: "100%" },
            }}
          >
            {!dynamicPriceAllowed && (
              <PriceInput
              label={t("servicePage.management.form.fixedPrice")}
                size="small"
              placeholder={t("servicePage.management.form.pricePlaceholder")}
                value={fixedPrice}
                onChange={(e) => setFixedPrice(Number(e.target.value))}
                error={!checkIfPricesAreValid() && submittedOnce}
                helperText={
                  !checkIfPricesAreValid() &&
                  submittedOnce &&
                  t("servicePage.management.form.priceError")
                }
                autoComplete="off"
                inputRef={(input) =>
                  input &&
                  !checkIfPricesAreValid() &&
                  submittedOnce &&
                  input.focus()
                }
                fullWidth
              />
            )}

            <Box>
              <FormControlLabel
                control={<Checkbox onChange={handleToggleDynamicPrices} />}
                label={t("servicePage.management.form.dynamicPriceLabel")}
                componentsProps={{ typography: { fontWeight: 600 } }}
              />
              <Typography textAlign="justify">
                  {t("servicePage.management.form.dynamicPriceDescription")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );

  const renderDynamicPrice = (
  <>
    {dynamicPriceAllowed ? (
        <>
          <ComercialInterfaceHeader title={t("servicePage.management.form.dynamicPriceTitle")} />
          <Box
            ref={(ref: any) =>
              ref &&
              !checkIfPricesAreValid() &&
              submittedOnce &&
              ref.querySelector('input[aria-invalid="true"]').focus()
            }
            sx={sharedStyles.dynamicPriceInputsContainer}
          >
            {weekdayKeys.map((key, index) => (
              <Box key={index} sx={{ maxWidth: "150px" }}>
                <DynamicPriceInput
                  value={prices[index]}
                  setValue={(value) => setPrices[index](value)}
                  label={t(`timeRange.days.${key}`)}
                  submittedOnce={submittedOnce}
                />
              </Box>
            ))}
          </Box>
        </>
      ) : null}
    </>
  );

  const renderImageGallery = (
    <>
      <ImageGalleryHeader
        label={t("storePage.management.add.images.add")}
        icon={<AddPhotoAlternateIcon />}
        setImages={setImages}
      />
      <ImageGalleryContainer>
        <GalleryImageList images={images} setImages={setImages} interable />
      </ImageGalleryContainer>
    </>
  );

  const renderEmployeeSelection = (
    <>
      <ComercialInterfaceHeader title={t("servicePage.management.form.employeeSelectionTitle")} />

      <Box sx={sharedStyles.serviceEmployeesGrid}>
        {employees &&
          employees.map((employee) => (
            <Box
              onClick={() => handleSelectEmployee(employee.id)}
              key={employee.id}
            >
              <CustomCard
                photoURL={employee.User.imagePreview}
                defaultPhoto={defaultEmployeeImage}
                header={""}
                primaryText={employee.User.name}
                secondaryText={""}
                isSelected={!!selectedEmployeeIds.includes(employee.id)}
              />
            </Box>
          ))}
      </Box>
      {noEmployeesSelected && (
        <Typography color="error">
            {t("servicePage.management.form.employeeSelectionError")}
        </Typography>
      )}
    </>
  );

  const renderAddServicePageContent = (
    <>
      <LeftMarginBackButton />

      <form
        onSubmit={onSubmit(handleServiceAndServiceStoreCreation)}
        style={sharedStyles.form}
      >
        {renderServiceData}
        {renderDynamicPrice}
        {renderImageGallery}
        {renderEmployeeSelection}

        {generalErrorMessage !== "" && (
          <Alert severity="error">{generalErrorMessage}</Alert>
        )}

        <Box sx={sharedStyles.dividedFormContainer}>
          <PrimaryButton
            label={t("servicePage.management.add.confirm")}
            isLoading={buttonsDisabled}
            icon={<AddIcon />}
            onClickAction={() => !submittedOnce && setSubmittedOnce(true)}
          />

          <SecondaryButton
            label={t("servicePage.management.add.cancel")}
            onClickAction={() => navigate("/services")}
            isDisabled={buttonsDisabled}
          />
        </Box>
      </form>
    </>
  );

  return (
    <Box sx={sharedStyles.sharedMainContainer}>
      <ComercialDrawer content={renderAddServicePageContent} />
    </Box>
  );
};

export default AddService;
